function InputBase(_: any): any {
  return {
    MuiInputBase: {
      styleOverrides: {
        // sizeSmall: {
        //   fontSize: '0.75rem'
        // }
      }
    }
  };
}
export { InputBase };
